import { useSearchParams } from 'next/navigation'

import type { FilterSlug } from '@/legacy-src/components/filters/filters.interface'
import { useMemoWithResultCheck } from '@/legacy-src/hooks/useMemoWithResultCheck'

export const useGetFilterValue = (slug: FilterSlug) => {
  const searchParams = useSearchParams()

  const paramValue = useMemoWithResultCheck(() => {
    const maybeValues = searchParams?.getAll(slug) ?? []
    const newValue = maybeValues.flatMap((value) => value.split(','))

    return newValue
  }, [searchParams, slug])

  return paramValue
}
